import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';

import { RequestHistory } from '../workflow/my-requests/commons/interfaces/my-requests.interface';
import { RequestFormService } from '../home/services/request-form.service';
import { catchError, from, of } from 'rxjs';
import { RequestsService } from '../home/services/requests.service';

export const DataRequestSolicitudIdResolverService: ResolveFn<RequestHistory[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const id = route.paramMap.get('id');
  return from(inject(RequestFormService).getRequestFormsId(id)).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};

export const DataRequestBeneficiariosSolicitudesBeneficio: ResolveFn<any[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  
  const dataNotification = route.queryParamMap.get('data_notification') ?? '{"id_benefit": 0}';
  const parsedData = JSON.parse(dataNotification);
  const id_benefit = parsedData["id_benefit"];
  return from(inject(RequestsService).get_beneficiarios_solicitud_beneficio(id_benefit)).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};